import { OrbitControls } from '@react-three/drei';
import PropTypes from 'prop-types';

import CameraIntro from './scene/CameraIntro';
import LightsIntro from './scene/LightsIntro';
import ButtonStart from './ButtonStart';
import TitleAnimation from './TitleAnimation';

function Intro({
  setShow, showValue, changeLoading, canClick,
}) {
  return (
    <group>
      <CameraIntro />
      <LightsIntro />
      <TitleAnimation showValue={showValue} />
      {!canClick
        ? (
          <ButtonStart
            setShow={setShow}
            changeLoading={changeLoading}
            canClick={canClick}
          />
        ) : null}
      <OrbitControls
        maxAzimuthAngle={0}
        maxPolarAngle={1.7}
        minAzimuthAngle={-0.5}
        minPolarAngle={1.3}
        enableZoom={false}
        enablePan={false}
      />
    </group>
  );
}

export default Intro;

Intro.propTypes = {
  setShow: PropTypes.func.isRequired,
  showValue: PropTypes.bool.isRequired,
  changeLoading: PropTypes.func.isRequired,
  canClick: PropTypes.bool.isRequired,
};
